angular.module('contabilidad.polizas')
  .service('ContabilidadPolizasFacturascanceladas', ContabilidadPolizasFacturascanceladas)

function ContabilidadPolizasFacturascanceladas ($http, $filter) {
  this.get = _get
  this.codificar = _codificar

  function _get (fechaInicio, fechaFin, idEmpresa) {
    return $http.get('/kendu/contabilidad/polizas/polizasfacturascanceladas', {
      params: {
        fechaInicio: fechaInicio.toYMD(),
        fechaFin: fechaFin.toYMD(),
        idEmpresa: idEmpresa,
      },
      schema: schema,
    })
  }

  var padEnd = (string, length) => string.substring(0, length).padEnd(length)

  function _codificar (data, inicio_poliza) {
    var cadenaPrincipal = '',
      cadA = 'P  AAAAMMDD    3      JJJJ 1 0          XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX' +
        '                                         11 1 0\\n',
      cadB = 'M1 CCCCCCCCCCCCCCCC               ZZZZZZZZZZZZZZZ      G YYYYYYYYY            0          0.0' +
        '                  NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN \\n',
      fechaA,
      fechaB,
      aux,
      indice = 0
    try {
      data.forEach(function (item) {
        if (item.folio) {
          fechaA = $filter('date')(item.fechaPoliza, 'yyyyMMdd')
          fechaB = padEnd('F-' + item.folio, 15)
          if (indice === 0) {
            cadenaPrincipal += cadA
              .replace('AAAAMMDD', fechaA)
              .replace('JJJJ', ('000' + inicio_poliza).slice(-4))
              .replace('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX', padEnd(item.descripcion, 60))
          }

          if (item.tipoMoneda === '1') {
            aux = padEnd('FACTURA#' + item.folio + ' ' + item.nombreCliente, 43)
          } else {
            aux = padEnd('FACTURA#' + item.folio + ' TC:' + item.tipoCambio + ' ' + item.nombreCliente, 43)
          }

          // Transacciones
          item.transacciones.forEach(function (transaccion) {
            cadenaPrincipal += cadB
              .replace('CCCCCCCCCCCCCCCC', padEnd(transaccion.cuentaContable.replace(/-/g, ''), 16))
              .replace('ZZZZZZZZZZZZZZZ', fechaB)
              .replace('G', transaccion.naturaleza === 'C' ? 0 : 1)
              .replace('YYYYYYYYY', padEnd((transaccion.importe.toFixed(2)), 9))
              .replace('NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN', aux)
          })
          inicio_poliza++
          indice++
        }
      })

      return cadenaPrincipal
    } catch (err) {
      console.error(err)
      return 'Error'
    }
  }

  var schema = {
    idProveedor: 'number',
    nombreCliente: 'string',
    fechaPoliza: 'date',
    Importe_Tasa: 'number',
    Subtotal: 'number',
    tipoCambio: 'number',
    total: 'number',
    fecha: 'date',
    fecha_cancelacion: 'date',
    transacciones: {
      cuentaContable: '',
      tipoMoneda: '',
      importe: 'number',

    },
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/polizas/services/ContabilidadPolizasFacturascanceladas.js